import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '40px 0 40px 0',
    }),

    header: css({
        marginBottom: '40px',
        textAlign: 'center',
    }),

    title: css({
        marginBottom: '10px',
    }),

    form: css({
        width: '40%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('lg')]: {
            width: '80%',
        },
    }),

    formField: css({
        '&& .MuiInputBase-input': {
            color: 'black !important',
            WebkitTextFillColor: 'black !important',
        },
        '&& label, && .MuiFormLabel-root': {
            color: `${theme.palette.text.secondary} !important`,
        },
    }),

    names: css({
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
        },
    }),

    room: css({
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
        },
    }),

    amount: css({
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',
        },
    }),

    checkbox: css({
        marginRight: '12px',
        marginLeft: '11px',
    }),

    btn: css({
        order: 2,
    }),
};
